export default __webpack_public_path__ + "static/media/flag-falkland-islands.095743a5.svg";